import { render, staticRenderFns } from "./HomePoints.vue?vue&type=template&id=373ae1e8&scoped=true"
import script from "./HomePoints.vue?vue&type=script&lang=ts"
export * from "./HomePoints.vue?vue&type=script&lang=ts"
import style0 from "./HomePoints.vue?vue&type=style&index=0&id=373ae1e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373ae1e8",
  null
  
)

export default component.exports